<div class="container-fluid mt-3">
  <div class="form-box p-2 mb-2 form-section">
    <form [formGroup]="proplayerData" (ngSubmit)="filterData(proplayerData.value)">
      <div class="row">
        <div class="form-group col-md-3">
          <label for="inputEmail4" class="game-histroy-font-color mb-1">Player</label>
          <input type="text" class="form-control" formControlName="name" placeholder="Enter Player name"
            [(ngModel)]="playerNames" (keyup)="playerInputChanges($event)" required />
          @if(suggestions.length > 0){
          <ul class="list-group search-Box mt-1">
            @for (item of suggestions; track $index) {
            <li class="list-group-item p-1" style="cursor: pointer;" (click)="suggestionValue(item)">
              {{ item }}
            </li>
            }
          </ul>
          }
        </div>
        <div class="form-group col-md-3">
          <label for="inputEmail4" class="game-histroy-font-color mb-1">Opponent</label>
          <input type="text" class="form-control" formControlName="opponent" placeholder="Enter Opponent name"
            [(ngModel)]="playerOpponent" (keyup)="opponentInputChange($event)" required />
          @if(opponentsuggestions.length > 0){
          <ul class="list-group search-Box mt-1">
            @for (item of opponentsuggestions; track $index) {
            <li class="list-group-item p-1" style="cursor: pointer;" (click)="opponentsuggestionValue(item)">
              {{ item }}
            </li>
            }
          </ul>
          }
        </div>
        <div class="form-group col-md-3">
          <label for="inputState" class="game-histroy-font-color mb-1">Result</label>
          <select class="form-select" formControlName="results">
            <option value="" disabled>Select result</option>
            <option value="win">Win</option>
            <option value="lost">Lost</option>
            <option value="draw">Draw</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="inputPassword4" class="game-histroy-font-color mb-1">Date</label>
          <input type="text" class="form-control" id="inputYear" formControlName="date" placeholder="YYYY"
            (input)="formatYear($event)">
        </div>

        <div class="form-group d-flex justify-content-center col-md-12 mt-2">
          <div class="d-flex align-items-center">
            <div class="square-radio">
              <input type="radio" id="radio1" value="white" name="side" formControlName="side" />
              <label for="radio1">white</label>

              <input type="radio" id="radio2" value="black" name="side" formControlName="side" />
              <label for="radio2">black</label>
            </div>

          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center m-3">
        <button type="submit" class="btn serach-btn">Search</button>
        <button type="button" class="btn reset-btn ms-3" (click)="formReset()">
          Reset
        </button>
      </div>
    </form>
  </div>

  <div class="table-responsive my-4" (scroll)="onScroll($event)">
    <table class="table table-striped mb-0">
      <thead class="table-head">
        <tr class="table-header table-header-sticky">
          <th scope="col">Event</th>
          <th scope="col">Place</th>
          <th scope="col">
            Date @if(SortDate == 'descendingDate'){
            <i class="fa-solid fa-arrow-up" style="cursor: pointer;" data-toggle="tooltip" data-placement="top"
              title="Ascending Date" (click)="ascendingDate('ascendingDate')"></i>
            } @else if(SortDate == 'ascendingDate'){
            <i class="fa-solid fa-arrow-down" style="cursor: pointer;" data-toggle="tooltip" data-placement="top"
              title="Descending Date" (click)="descendingDate('descendingDate')"></i>
            }
          </th>
          <th scope="col">White</th>
          <th scope="col">Black</th>
          <th scope="col">Result</th>
        </tr>
      </thead>
      <tbody style="border-color: rgb(106 106 126)">
        @if(playersRecord.length > 0){
        @for (records of playersRecord; track $index) {
        <tr (click)="recondIddata(records._id)" style="cursor: pointer">
          <td>{{ records.Event }}</td>
          <td>{{ records.Site }}</td>
          <td>{{ formatDate(records.Date) }}</td>
          <td>{{ records.White }}</td>
          <td>{{ records.Black }}</td>
          <td>{{ records.Result }}</td>
        </tr>
        } @if(isLoading){
        <tr>
          <td colspan="7">
            <div class="d-flex justify-content-center">
              <p class="loader ms-3 m-0"></p>
            </div>
          </td>
        </tr>
        }
        }@else{
        <tr>
          <td colspan="6">
            <div class="d-flex justify-content-center">
              <p class="text-white m-0">No game Record's.</p>
            </div>
          </td>
        </tr>
        }

      </tbody>
    </table>
  </div>
</div>

<app-login-popup [displayStyle]="modalDisplayStyle" (myout)="GetChildData($event)"></app-login-popup>